import axios from "axios";

export const getCountries = async (): Promise<Map<string, string>> => {
  const response = await axios.get("/api/countries");
  return response.data;
};
